import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { CalendarioReforma, DateReforma, IConfigReformaPensiones } from "@interfaces/config-reforma-pensiones.interface";
import { IonContent } from "@ionic/angular";

// Definimos una interfaz para cada punto de contenido en un evento
interface TimelineContent {
  text: string;
  highlighted: boolean;
}

// Definimos la interfaz para un evento completo en la línea de tiempo
interface TimelineItem {
  status: "listo" | "activo" | "default";
  date: {
    month: string;
    year: string;
  };
  content: TimelineContent[];
}

@Component({
    selector: "app-fechas-claves",
    templateUrl: "./fechas-claves.component.html",
    styleUrl: "./fechas-claves.component.scss",
    standalone: false
})
export class FechasClavesComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() calendarioBeneficios: IConfigReformaPensiones = {} as IConfigReformaPensiones;

  timelineData: CalendarioReforma[] = [];


  ngOnInit() {
    if (this.calendarioBeneficios["calendario-beneficios"] && this.calendarioBeneficios["calendario-beneficios"].length > 0) {
      this.timelineData = this.getCalandarioFormat(this.calendarioBeneficios);
    } else {
      this.timelineData = [];
    }
  }
  getCalandarioFormat(calendarioBeneficios: IConfigReformaPensiones): CalendarioReforma[] {
    return calendarioBeneficios["calendario-beneficios"].map(calendario => {
      calendario.status = this.getStatus(calendario.date);
      return calendario;
    })
  }
  getStatus(date: DateReforma): string {
    const currentDate = new Date();
    // Convierte el nombre del mes a número (base 0)
    const months = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const monthIndex = months.findIndex(
      m => m.toLowerCase() === date.month.toLowerCase()
    );
    if (monthIndex === -1) {
      return "default";
    }

    // Crear fechas base con día 1
    const eventYear = Number(date.year);
    const eventMonth = monthIndex;
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    if (eventYear < currentYear || (eventYear === currentYear && eventMonth < currentMonth)) {
      return "listo"; // Evento pasado
    } else if (eventYear === currentYear && eventMonth === currentMonth) {
      return "activo"; // Evento actual
    } else {
      return "default"; // Evento futuro
    }
  }

  idColumnEmit() {
    setTimeout(() => {
      const element = document.getElementById('container-fechas');
      if (element) {
        this.content.scrollToPoint(0, 1000, 500);
      }

    }, 500);
  }
}
